import { JournalLine, ReconciliationLine } from "./api";

const parseAmount = (value?: string | number): number => {
    if (value === undefined || value === null) return 0;
    if (typeof value === "number") return value;
    const numeric = parseFloat(value.replace(/[^0-9.-]/g, ""));
    return Number.isFinite(numeric) ? numeric : 0;
};

export function generateReconciliationPairs(
    debitLines: JournalLine[],
    creditLines: JournalLine[]
): ReconciliationLine[] {
    const pairs: ReconciliationLine[] = [];

    // Clone to avoid mutating inputs and add remaining tracking
    const debits = debitLines.map(d => ({
        ...d,
        remaining: parseAmount(d.amount)
    }));

    const credits = creditLines.map(c => ({
        ...c,
        remaining: parseAmount(c.amount)
    }));

    let dIndex = 0;
    let cIndex = 0;

    while (dIndex < debits.length && cIndex < credits.length) {
        const debit = debits[dIndex];
        const credit = credits[cIndex];

        // Skip exhausted lines
        if (debit.remaining <= 0.005) { // Epsilon check
            dIndex++;
            continue;
        }
        if (credit.remaining <= 0.005) {
            cIndex++;
            continue;
        }

        // Determine amount to pair (min of remaining on either side)
        const amount = Math.min(debit.remaining, credit.remaining);

        // Only add if amount is significant
        if (amount > 0.005) {
            pairs.push({
                debit_account: debit.account,
                credit_account: credit.account,
                amount: amount.toFixed(2),
                description: debit.description || credit.description
            });

            // Update remaining
            debit.remaining -= amount;
            credit.remaining -= amount;

            // Fix precision issues
            debit.remaining = Math.round(debit.remaining * 100) / 100;
            credit.remaining = Math.round(credit.remaining * 100) / 100;
        } else {
            // Prevent infinite loop if amounts are tiny but positive
            if (debit.remaining < credit.remaining) dIndex++;
            else cIndex++;
        }
    }

    return pairs;
}
